import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login/Index.vue"),
  },
  {
    path: "/",
    name: "Index",
    component: () => import("../views/Home/Index.vue"),
  },
  {
    path: "/main",
    name: "Main",
    component: () => import("../views/Home/Main.vue"),
  },
  {
    path: "/yh",
    name: "YongHu",
    component: () => import("../views/YongHu/List.vue"),
  },
  {
    path: "/js",
    name: "JueSe",
    component: () => import("../views/JueSe/List.vue"),
  },
  {
    path: "/zd",
    name: "ZiDian",
    component: () => import("../views/ZiDian/List.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "not-found",
    component: () => import("../views/Home/404.vue"),
  },
  {
    path: "/hf/:dh",
    name: "HuiFu",
    component: () => import("../views/HuiFu/Index.vue"),
  },
  {
    path: "/hf/wx",
    name: "WeChat",
    component: () => import("../views/HuiFu/WeChat.vue"),
  },
  {
    path: "/hf/zfb",
    name: "ZhiFuBao",
    component: () => import("../views/HuiFu/ZfbH5.vue"),
  },
  {
    path: "/lydd/pay/:id",
    name: "HuiFuLyddPay",
    component: () => import("../views/HuiFu/Lydd/Index.vue"),
  },
  {
    path: "/lydd/wx",
    name: "HuiFuLyddPayWx",
    component: () => import("../views/HuiFu/Lydd/WeChat.vue"),
  },
  {
    path: "/h5/sp",
    name: "H5ShangPin",
    component: () => import("../views/ShangPin/H5List.vue"),
  },
  {
    path: "/h5/sp/order/:id",
    name: "H5ShangPinOrder",
    component: () => import("../views/ShangPin/H5Order.vue"),
  },
  {
    path: "/h5/payment/:orderId",
    name: "H5Payment",
    component: () => import("@/views/ShangPin/H5Payment.vue"),
  },
  {
    path: "/h5/ticket/:orderId",
    name: "H5TicketEntry",
    component: () => import("@/views/ShangPin/H5TicketEntry.vue"),
  },
  {
    path: "/h5/gold/:orderId?",
    name: "H5WechatGoldPage",
    component: () => import("@/views/ShangPin/H5WechatGoldPage.vue"),
  },
  {
    path: "/tk/:code",
    name: "H5TicketShortLink",
    component: () => import("@/views/ShangPin/H5TicketShortLink.vue"),
  },
  {
    path: "/HeXiaoShangHu/List",
    name: "HeXiaoShangHuList",
    component: () => import("@/views/HeXiaoShangHu/List.vue"),
    meta: { title: "核销商户" },
  },
  {
    path: "/HeXiaoJiLu/List",
    name: "HeXiaoJiLuList",
    component: () => import("@/views/HeXiaoJiLu/List.vue"),
    meta: { title: "核销记录" },
  },
  {
    path: "/da-ping",
    name: "DaPing",
    component: () => import("@/views/DaPing/DaPing.vue"),
    meta: { title: "景区数据驾驶舱" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
